/**
 * Responsible for checking whether a user's token is still valid when navigating between routes.
 */

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, CanActivateChild } from '@angular/router';
import { Observable, of } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { mergeMapTo, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(true);
    // return this.checkUser();
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }

  canLoad(state: Route): Observable<boolean> {
    return of(true);
    // return this.checkUser();
  }

  checkUser(): Observable<boolean> {
    return this.oidcSecurityService.checkAuth().pipe(
      map(({ isAuthenticated, userData, accessToken, idToken }) => {
        if (!isAuthenticated) {
          console.log("auth guard redirect to unauthorized");
          this.router.navigate(['/unauthorized']);
          return false;
        }
        return true;
      })
    );
  }
}
